import React from 'react'
// import map from 'lodash/map'
import ContentSelect from '../../../core/components/content-select/ContentSelect'
import InteractiveContentBlocks from '../../../core/components/interactive-content-blocks/InteractiveContentBlocks'
// import VisibleContentFilter from '../../topic/containers/VisibleContentFilter'
import {UniLink} from '../../../core/components/unilink/index'
import LoadingSpinner from '../../../core/components/loading-spinner/LoadingSpinner'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './grandmasterSolutions.css'

const GrandmasterSolutions = ({solutions, activeSolution, chooseActiveSolution, isLoading, openShare, colorSubject, toggleVote, report}) => {
  const {author, voteCount, id, renderedContent, type, currentUserHasVoted} = activeSolution
  return (
    <div className='grandmaster-solutions'>
      <div className='grandmaster-solutions__select-container'>
        <span className='grandmaster-solutions__section-title'>
          Solutions
        </span>
        <div className='grandmaster-solutions__select'>
          <ContentSelect
            className='grandmaster-solutions__content-select'
            content={solutions}
            chooseActiveFromId={chooseActiveSolution}
            activeId={id}
            colorSubject={colorSubject}
            toggleVote={toggleVote}
            dark
          />
        </div>
        {
          isLoading
            ? (
              <div className='grandmaster-solutions__content-blocks-container'>
                <div className='grandmaster-solutions__content-blocks-header'>
                  <UniLink
                    className='grandmaster-solutions__content-blocks-votes' />
                  <div className='grandmaster-solutions__content-blocks-authors' />
                </div>
                <LoadingSpinner delay={200} />
                <div className='gm-interactive-content__footer'>
                  <UniLink><FontAwesomeIcon icon={['fa', 'exclamation-circle']} /> Report</UniLink>
                </div>
              </div>
            )
            : (
              <div className='grandmaster-solutions__content-blocks-container'>
                <div className='grandmaster-solutions__content-blocks-header'>
                  <UniLink
                    onClick={()=>{
                      toggleVote(type, id)
                    }}
                    className='grandmaster-solutions__content-blocks-votes'>
                    { currentUserHasVoted ? <FontAwesomeIcon icon={['fa', 'heart']} /> : <FontAwesomeIcon icon={['far', 'heart']} /> } {voteCount}
                  </UniLink>
                  <div className='grandmaster-solutions__content-blocks-authors'>
                    {`Solution by ${author.displayName}`}
                  </div>
                </div>
                <InteractiveContentBlocks
                  content={renderedContent}
                  type={type}
                  as='grandmasterSolution'
                />
                <div className='gm-interactive-content__footer'>
                  <UniLink
                    onClick={()=>report(activeSolution)}><FontAwesomeIcon icon={['fa', 'exclamation-circle']} /> Report</UniLink>
                </div>
              </div>
            )
        }
      </div>
    </div>
  )
}

export default GrandmasterSolutions



// WEBPACK FOOTER //
// ./src/domains/grandmaster/components/GrandmasterSolutions.js